import React from 'react';
import { useTranslation } from 'react-i18next';
import { HtmlTrans, SectionHeader, Typography } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  ul: {
    fontSize: '1.125rem',
  },
  ol: {
    fontSize: '1.125rem',
  },
  a: {
    textDecoration: 'none',
    color: theme.color.link.linkDefault01,
  },
}));

const IPsleInstruction = ({ examRegistrationType }: { examRegistrationType: string }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <SectionHeader title={t('exam->>RegisterExamInstructions.IPSLEInstructionsTitle')} />
      {examRegistrationType === 'SUPPLEMENTARY' ? (
        <ol className={`${classes.ol}`}>
          <li>
            <Typography variant="body1" className={classes.ol}>
              {t('exam->>RegisterExamInstructions.IPSLEInstructionsLateRegistrationDetails1')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              <HtmlTrans i18nKey="exam->>RegisterExamInstructions.IPSLEInstructionsLateRegistrationDetails2" />
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              {t('exam->>RegisterExamInstructions.IPSLEInstructionsLateRegistrationDetails3')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              {t('exam->>RegisterExamInstructions.IPSLEInstructionsLateRegistrationDetails4')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              <HtmlTrans i18nKey="exam->>RegisterExamInstructions.IPSLEInstructionsLateRegistrationDetails5" />
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              <HtmlTrans i18nKey="exam->>RegisterExamInstructions.IPSLEInstructionsLateRegistrationDetails6" />
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              {t('exam->>RegisterExamInstructions.IPSLEInstructionsLateRegistrationDetails7')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              {t('exam->>RegisterExamInstructions.IPSLEInstructionsLateRegistrationDetails8')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              <HtmlTrans
                i18nKey="exam->>RegisterExamInstructions.IPSLEInstructionsLateRegistrationDetails9"
                values={{
                  aClass: classes.a,
                }}
              />
            </Typography>
          </li>
        </ol>
      ) : (
        <ol className={`${classes.ol}`}>
          <li>
            <Typography variant="body1" className={classes.ol}>
              <HtmlTrans i18nKey="exam->>RegisterExamInstructions.IPSLEInstructionsExamRegistrationDetails1" />
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              {t('exam->>RegisterExamInstructions.IPSLEInstructionsExamRegistrationDetails2')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              {t('exam->>RegisterExamInstructions.IPSLEInstructionsExamRegistrationDetails3')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              <HtmlTrans i18nKey="exam->>RegisterExamInstructions.IPSLEInstructionsExamRegistrationDetails4" />
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              <HtmlTrans i18nKey="exam->>RegisterExamInstructions.IPSLEInstructionsExamRegistrationDetails5" />
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              {t('exam->>RegisterExamInstructions.IPSLEInstructionsExamRegistrationDetails6')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              {t('exam->>RegisterExamInstructions.IPSLEInstructionsExamRegistrationDetails7')}
            </Typography>
          </li>
          <li>
            <Typography variant="body1" className={classes.ol}>
              <HtmlTrans
                i18nKey="exam->>RegisterExamInstructions.IPSLEInstructionsExamRegistrationDetails8"
                values={{
                  aClass: classes.a,
                }}
              />
            </Typography>
          </li>
        </ol>
      )}
    </>
  );
};
export default IPsleInstruction;
